import React, { useEffect, useState } from "react";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import img from "../../assets/icons/send.png";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import axios from "axios";
import { toast } from "react-toastify";
const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    city: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSending, setIsSending] = useState(false);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const validateForm = () => {
    const newErrors = {};

    // Name
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    // Phone
    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be 10 digits";
    }

    // Email
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email address";
    }

    // City
    if (!formData.city.trim()) {
      newErrors.city = "City is required";
    }

    // Message
    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Message should be at least 10 characters";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    //   setIsSending(true);

    axios
      .post("/sendForm.php", formData)
      .then((response) => {
        console.log("Response Data:", response.data);

        if (response.data?.type === "success") {
          setFormData({
            name: "",
            phoneNumber: "",
            email: "",
            city: "",
            message: "",
          });
          toast.success(
            "Contact form successfully submitted. Thank you, We will get back to you soon!",
          );
          setIsSending(false);
        } else {
          toast.error("An unexpected error occurred.");
          setIsSending(false);
        }
      })
      .catch((error) => {
        console.log("Error Response:", error.response);

        if (error.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Failed to send message. Please try again.");
        }

        console.error(error);
        //   setIsSending(false);
      });
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
  return (
    <>
      <title>Contact to SLN Educational Society</title>
      <div className="lg:pt-40 pt-36 pb-16 relative " id="contact-us">
        <div className=" lg:top-5 top-20 absolute right-2 ">
          <img src={img} alt="about our education " className="lg:w-80 w-48" />
        </div>
        <div className="xl:max-w-screen-xl w-11/12 mx-auto flex flex-col justify-center items-center">
          <h2
            className="xl:text-5xl sm:text-4xl text-3xl font-semibold text-center py-4 text-[#1a1a1a]"
            style={{
              lineHeight: "1.2em",
            }}
          >
            Contact Us
          </h2>

          <div className="md:mt-16 mt-10 grid lg:grid-cols-2 gap-8  w-full">
            <div className="flex flex-col xl:gap-8 gap-4">
              {/* Address */}
              <div className="grid xl:grid-cols-2 grid-cols-1 lg:gap-8 gap-4">
                <div className="bg-[#eef4f5] rounded-3xl p-6">
                  <div className="flex flex-row items-center gap-4 pb-3">
                    <div className="w-12 h-12 bg-[#005064] rounded-2xl flex items-center justify-center">
                      <LocalPhoneIcon className="text-white" />
                    </div>
                    <h3 className="text-xl font-semibold">Contact Number</h3>
                  </div>

                  <p className="text-center">
                    <a
                      href="tel:+919848433744"
                      className="text-[#005064] text-xl  mt-1 font-bold hover:opacity-65 transition-all duration-200"
                    >
                      +91 98484 33744
                    </a>
                  </p>
                </div>
                <div className="bg-[#eef4f5] rounded-3xl p-6">
                  <div className="flex flex-row items-center gap-4 pb-3">
                    <div className="w-12 h-12 bg-[#005064] rounded-2xl flex items-center justify-center">
                      <EmailOutlinedIcon className="text-white" />
                    </div>
                    <h3 className="text-xl font-semibold">Email Address</h3>
                  </div>
                  <p className="text-center">
                    <a
                      href="mailto:info@slned.com"
                      className="text-[#005064] text-xl font-bold hover:opacity-65 transition-all duration-200"
                    >
                      info@slned.com
                    </a>
                  </p>
                </div>
              </div>

              <div className="bg-[#eef4f5] rounded-3xl p-6">
                <div className="flex flex-row items-center gap-4 pb-3">
                  <div className="w-12 h-12 bg-[#005064] rounded-2xl flex items-center justify-center">
                    <LocationOnOutlinedIcon className="text-white" />
                  </div>
                  <h3 className="text-xl font-semibold">Head Office</h3>
                </div>

                <a
                  href="https://maps.app.goo.gl/XWrncJgXYWr4w8G36"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#005064] text-base font-medium hover:opacity-65 transition-all duration-200"
                >
                  Sy No 882, Plot No 117, Sai Sree Nilaya Residency, Gandi
                  Maisamma Temple Road, Seethariguda, Medchal Check Post,
                  Hyderabad, Medchal Malkajgiri, Telangana, 501401
                </a>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
              {/* Name */}

              <div className="grid lg:grid-cols-2 grid-cols-1 xl:gap-8 gap-4">
                <div>
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-3 border-[#edf3f4] focus:border-[#005464]"
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                  )}
                </div>

                {/* Phone */}
                <div>
                  <input
                    type="tel"
                    name="phoneNumber"
                    placeholder="Phone Number"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    inputMode="numeric"
                    className="w-full border rounded-xl p-3 border-[#edf3f4] focus:border-[#005464]"
                  />
                  {errors.phoneNumber && (
                    <p className="text-red-500 text-sm mt-1">{errors.phoneNumber}</p>
                  )}
                </div>
              </div>
              <div className="grid lg:grid-cols-2 grid-cols-1 xl:gap-8 gap-4">
                {/* Email */}
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-3 border-[#edf3f4] focus:border-[#005464]"
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                  )}
                </div>

                {/* City */}
                <div>
                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={formData.city}
                    onChange={handleChange}
                    className="w-full border rounded-xl p-3 border-[#edf3f4] focus:border-[#005464]"
                  />
                  {errors.city && (
                    <p className="text-red-500 text-sm mt-1">{errors.city}</p>
                  )}
                </div>
              </div>

              {/* Message */}
              <div>
                <textarea
                  name="message"
                  rows="4"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full border rounded-xl p-3 resize-none border-[#edf3f4] focus:border-[#005464]"
                />
                {errors.message && (
                  <p className="text-red-500 text-sm mt-1">{errors.message}</p>
                )}
              </div>

              <button
                className={`${isSending ? "cursor-not-allowed" : "cursor-pointer"} py-2.5 px-6 flex flex-row justify-center items-center gap-2  border border-[#005064] hover:bg-[#D4E9EF] opacity-70 hover:text-[#005064] bg-[#005064] text-[#D4E9EF]  rounded-full text-base transition-all duration-200`}
              >
                Submit <SendOutlinedIcon />
              </button>
            </form>
          </div>
          <div className="relative w-full md:h-[450px] h-[300px]  rounded-xl mt-8 overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4510.7594003749045!2d78.48067627578273!3d17.616786496154965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb8753e0295d29%3A0x7d5bc0f5c7da44dd!2sENDULA%20INFRA%20LLP!5e1!3m2!1sen!2sin!4v1781094923179!5m2!1sen!2sin"
              className="w-full h-full"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              title="Location"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
